import React, {Component} from "react";
import { Container, Button } from "shards-react";
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import history from '../history';


class NotFound extends Component {
    goBack = () => {
      history.goBack();
    }

    render() {
        return (
          <Container fluid className="main-content-container px-4 pb-4">
            <div className="error">
              <div className="error__content">
                <h3>{this.context.t('This page is not available')} </h3>
                <p>{this.context.t('It is possible that the link you followed is broken or the page has been deleted.')}</p>
                <Button pill onClick={e => {this.goBack()}}>&larr; {this.context.t('Go Back')}</Button>
              </div>
            </div>
          </Container>
        );
    }
}

NotFound.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(NotFound)
